import { store } from '../store';
import { createApp } from 'vue';
import { sendPetition } from './scripts';
import Multiselect from '@vueform/multiselect';
import Vue from 'vue';
import vSelect from 'vue-select';

import comarques from '../../assets/data/municipalities.json';

if ( document.querySelector( '.c-technical-form-module' ) ) {
	const app_courses_module = createApp( {
		data() {
			return {
				formFirstname: '',
				formLastname: '',
				formPhone: '',
				formEmail: '',
				formState: 'Barcelona',
				formCity: '',
				formCityName: '',
				formMunicipality: '',
				formMunicipalityName: '',
				formStreet: '',
				formNumber: '',
				formStair: '',
				formFloor: '',
				formDoor: '',
				formJobs: '',
				formSpecialities: '',
				formDocument: '',
				formComment: '',
				formTerms: '',

				formFirstnameError: false,
				formLastnameError: false,
				formPhoneError: false,
				formEmailError: false,
				formStateError: false,
				formCityError: false,
				formMunicipalityError: false,
				formStreetError: false,
				formNumberError: false,
				formJobsError: false,
				formCommentError: false,
				formTermsError: false,


				form_open: true,
				form_success: true,

				work_options: [],
				jobs_value: [],
				jobs_options: [
					{value:"1", label: "Certificat Habitatge Usat (Cedula d'Habitabilitat)"},
					{value:"2", label: "Certificat d'Eficiència Energetica"},
					{value:"3", label: "Informe"},
					{value:"4", label: "Tècnic per reforma i/o acondicionament de local"},
					{value:"5", label: "Tècnic per reforma d'habitatge"},
					{value:"6", label: "Tècnic per reforma d'Edifici"},
					{value:"7", label: "ITE (Inspecció Tècnica d'Edificis)"},
					{value:"8", label: "Test Aluminós"},
					{value:"9", label: "Altres (cal definir a observacions)"},
					{value:"10", label: "Seguretat a les obres (Coord/est.bàsic s.i salut)"},
					{value:"11", label: "Projecte d'Activitats"},
					{value:"12", label: "Tècnic de Capçalera"},
				],
				selected_comarca: 0,
				selected_comarca_towns: [],
				comarques_list: [],
				towns_list: [],
				towns_multilist: [],
				loading: false
			};
		},
		components: {
			Multiselect,
			'v-select':vSelect
		},
		computed: {
			clientLogged() {
				return store.getters[ 'account/clientLogged' ];
			},
			sessionInfo() {
				return store.getters[ 'account/sessionInfo' ];
			},
		},
		mounted() {
			this.selected_comarca = 0;
			this.towns_multilist.push({id:0,cities:[]});
			comarques.forEach((comarca,index)=>{
				this.comarques_list.push({val:comarca.value, id:index+1, name:comarca.name})
				let aux_arr = [];
				comarca.cities.forEach(city=>{
					this.towns_list.push({id:city.id,name:city.name});
					aux_arr.push({id:city.id,name:city.name,county_idx:index+1});
				})
				this.towns_multilist.push({id:index+1,cities:aux_arr});
			})
			this.towns_list.sort(this.compareTowns);
			this.selected_comarca_towns = this.towns_list;
		},
		watch: {
			sessionInfo() {
				switch ( this.sessionInfo.result.statusCode ) {
					case 200:
						console.log( this.sessionInfo );
						break;
					case 401:
						console.log( 'User Error' );
						break;
					case 500:
						console.log( 'Password Error' );
						break;

					default:
						break;
				}
			},
		},
		methods: {
			compareTowns( a, b ) {
				if ( parseInt(a.id) < parseInt(b.id) ){
				  	return -1;
				}
				if ( parseInt(a.id) > parseInt(b.id) ){
				  	return 1;
				}
				return 0;
			},
			checkJobs(){
				this.generateJobsArr();
			},
			changeComarca(e){
				//console.log(e.target)
				let value = e.target.value;
				let text = e.target.options[e.target.selectedIndex].text;
				let id = e.target.options[e.target.selectedIndex].dataset['id'];
				//console.log(value);
				//console.log(text);
				//console.log(id);
				this.selected_comarca = id;
				this.formMunicipality = '';
				this.selected_comarca_towns = this.towns_multilist[this.selected_comarca].cities;
				//console.log(this.selected_comarca)
			},
			changeTown(e){
				console.log(e.target)
			},
			generateJobsArr(){
				let jobsArr = [];
				this.jobs_value.forEach(val=>{
					jobsArr.push(val);
				})
				return jobsArr;
			},
			validateData(jobsArr){
				let rePhone = new RegExp("^[0-9]{9}$");
				let reEmail = new RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-]+$");
				this.formFirstnameError = false;
				this.formLastnameError = false;
				this.formPhoneError = false;
				this.formEmailError = false;
				this.formStateError = false;
				this.formCityError = false;
				this.formMunicipalityError = false;
				this.formStreetError = false;
				this.formNumberError = false;
				this.formCommentError = false;
				this.formJobsError = false;
				this.formTermsError = false;

				let errors = false;
				if (this.formFirstname.length < 2) {
					this.formFirstnameError = true;
					errors = true;
				}
				if (this.formLastname.length < 2) {
					this.formLastnameError = true;
					errors = true;
				}
				if (!rePhone.test(this.formPhone)) {
					this.formPhoneError = true;
					errors = true;
				}
				if (!reEmail.test(this.formEmail)) {
					this.formEmailError = true;
					errors = true;
				}
				this.formCityName = '';
				let foundComarca = this.comarques_list.find(o => o.val === this.formCity);
				if (!foundComarca) {
					this.formCityError = true;
					errors = true;
				}else{
					this.formCityName = foundComarca.name;
				}
				this.formMunicipalityName = '';
				let foundMunicipality = this.towns_list.find(o => o.id === this.formMunicipality);
				if (!foundMunicipality) {
					this.formMunicipalityError = true;
					errors = true;
				}else{
					this.formMunicipalityName = foundMunicipality.name;
				}
				if (this.formStreet.length < 5) {
					this.formStreetError = true;
					errors = true;
				}
				if (this.formNumber.length == 0) {
					this.formNumberError = true;
					errors = true;
				}
				if (jobsArr.length == 0) {
					this.formJobsError = true;
					errors = true;
				}
				if(jobsArr.filter(job=>job == 9) > 0 && this.formComment.length == 0){
					this.formCommentError = true;
					errors = true;
				}
				if (!this.formTerms) {
					this.formTermsError = true;
					errors = true;
				}
				return errors;
			},
			sendForm( e ) {
				e.preventDefault();
				this.loading = true
				let arr = this.generateJobsArr();
				if (!this.validateData(arr)) {
					const url = '/wp-content/themes/cateb/src/services/forms/technicalRequest.php?' +
							'accountId=' + this.sessionInfo.id +
							'&formFirstname=' + this.formFirstname +
							'&formLastname=' + this.formLastname +
							'&formPhone=' + this.formPhone +
							'&formEmail=' + this.formEmail +
							'&formState=' + this.formState +
							'&formCity=' + this.formCityName +
							'&formMunicipality=' + this.formMunicipalityName +
							'&formStreet=' + this.formStreet +
							'&formNumber=' + this.formNumber +
							'&formStair=' + this.formStair +
							'&formFloor=' + this.formFloor +
							'&formDoor=' + this.formDoor +
							'&formJobs=' + JSON.stringify(arr) +
							'&formSpecialities=' + this.formSpecialities +
							'&formDocument=' + this.formDocument +
							'&formComment=' + this.formComment +
							'&formTerms=' + this.formTerms;
					sendPetition( url, ( data ) => {
						this.loading = false;
						if(data.result.statusCode==200){
							this.form_success = true;
							this.form_open = false;
						}else{
							this.form_success = false;
							this.form_open = false;
						}
						window.scrollTo({top: 0, behavior: 'smooth'});
					} );

				}
				else{
					console.log("validación erronea")
					this.loading = false;
				}

			},
		},
	}
	).mount( document.querySelector( '.c-technical-form-module' ) );
}
